<div #appLogo class="app-logo" resizeObserver (resizeObserved)="onResize($event)" ></div>
